import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const updateUserStaff = createAsyncThunk(
  "Staff/updateUserStaff",
  async (data, thunkAPI) => {
    const { handleSuccess, handleError } = data;
    try {
      const resp = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/users/staff-management/schedule/${data.id}`,
        {
          ...data.schema,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (resp.data && handleSuccess) {
        handleSuccess();
      }
      return resp.data;
    } catch (error) {
      if (error.response) {
        if (handleError) {
          handleError(
            error.response.data.errorMessage || error.response.data.message
          );
        }
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        if (handleError) {
          handleError(error.message);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
